import { useVuelidate } from '@vuelidate/core';
import { required, email, sameAs } from '@vuelidate/validators';
import axios from 'axios';

const downloadApp = {
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            api: '',
            email: '',
            terms: false,
            error: false,
            isSubmitted: false
        }
    },
    validations() {
        return {
            email: { required, email },
            terms: { sameAs: sameAs(true) }
        }
    },
    methods: {
        async handleSubmit() {
            let isValid = await this.v$.$validate();
            if (isValid) {
                const putResponse = await this.putData();
                if (putResponse && putResponse.status === 200) {
                    this.isSubmitted = true;
                } else {
                    this.error = true;
                }
            }
        },
        async putData() {
            let response = null;
            try {
                response = await axios.put(this.api, { 'Email': this.email, 'NewsletterSignup' : this.terms });
            } catch (error) {
                console.log(error);
            }
            return response;
        }
    },
    mounted() {
        this.api = this.$el.parentNode.action;
    }
}

export default downloadApp;